<script>
import formcombobox from "@/router/views/FormComponet/formcombobox.vue";
import Api from "@/helpers/apibtoast";
import Sabit from "@/helpers/apigeneric";

export default {
  mixins: [Api, Sabit],
  props: ["KontrolVerileri"],
  data() {
    return {
      Page: {
        PageNumber: "1",
        PageSize: "9999",
        PageDataSize: "1",
      },
      TableData: [],
      AddEdit: "",
      DataUpdate: null,
      FormData: {},
      FormDataType: {
        Tamamlanma: { FieldName: "Tamamlanma", Field: "combobox", FieldTitle: "", ComboDataArray: [{"Id":"1","Value":"Tamamlanmadı"},
          {"Id":"2","Value":"Tamamlandı"},{"Id":"3","Value":"İyileştirilmekte"}], Disabled: false
      },
      },
    };
  },
  watch:{
    KontrolVerileri(){
      this.Get();

    },
  },
  validations: {
    FormData: {
        Tamamlanma: {},
    },
  },
  components: {
    formcombobox,
  
  },
  methods: {


    Get() {
        this.FormData = this.KontrolVerileri;
        if(this.KontrolVerileri.Onay == 1){
          this.FormDataType.Tamamlanma.Disabled = true;
        }

    },
    EylemTableUpdate(){
      this.$emit("TableUpdateKontrolData");
    },
    StrKontrolUpdate(){
      if(this.FormData.Tamamlanma == ""){
        this.FormData.Tamamlanma = null;
      }
      this.Update("StrRisklerGirislerCevap", this.FormData).then((res) => {
        if(res){
          this.$emit("TableUpdate");
          this.$emit("TableUpdateKontrolData");

        }
        });
        }
  },
  created() {

  },
};
</script>
<template>
  <div class="row">
    <td>

    <formcombobox 
                            :FormDataType="FormDataType.Tamamlanma" 
                            :Value="FormData.Tamamlanma" 
                            :v="$v.FormData.Tamamlanma" 
                            @input="(FormData.Tamamlanma = $event), StrKontrolUpdate(Data)"  
                            @change="EylemTableUpdate()"
                            />
    <b-button class="mx-2" v-if="FormData.Tamamlanma > 0" v-b-modal.EylemKontrolAciklama @click="$emit('Data', FormData)" variant="outline-info">Açıklama</b-button>
    <b-button class="mx-2" v-if="FormData.Tamamlanma == 2" v-b-modal.EylemKontrolKanit @click="$emit('Data', FormData)"  variant="outline-warning">Kanıt</b-button>
 </td>
  </div>
  


</template>
